const content = {
  pageTitle: "Customer Sales Incentive{symbol}",
  cmlLink: "View Customer List",
  bannerTile: {
    bonusCapped: "This incentive is capped at {cap}.",
    notEligible: "Not Eligible",
    bonusAmountLabel: "Bonus Amount",
    statusManuallyDenied: "Status Manually Denied",
    noLongerEligible: "No Longer Eligible",
    noLongerEligibleSubtitle: "You are no longer eligible for the Customer Sales Incentive{symbol} program.",
  },
  deniedHeld: {
    held: "Your award is on hold.",
    heldSubtitle: "If you require more information, please contact Customer Support for further details.",
    denied: "You are not eligible for the Customer Sales Incentive{symbol} in {currentMonth} {currentYear}",
    contactCustomerCare: "If you require more information, please contact Customer Support for further details.",
  },
  manualApproval: {
    message: "The Customer Sales Incentive{symbol} has been manually approved.",
    contactCustomerCare: "If you require more information, please contact Customer Support for further details.",
  },
  graduated: {
    earningPerfBonus: "Congratulations! You are earning a {level}% Performance Bonus.",
    aboveRangeSubtitle:
      "The Customer Sales Incentive{symbol} is available to business owners at or below 9% Performance Bonus level. Your current qualification can earn you higher bonuses from the Performance Bonus Schedule than what CSI{symbol} rewards.",
    subtitle: "Based on {gpv} GPV",
    notEligible: "Not Eligible for CSI{symbol}",
    notEligibleSubtitle: "You do not meet the current eligibility requirements.",
    congratulations: "Congratulations! You have graduated at {level}%.",
  },
  bonusTracker: {
    title: "Bonus Tracker",
    csiMultiplierLabel: "Your Current CSI{symbol} Multiplier",
    gpvLabel: "{gpv} GPV",
    gpvVolumeLabel: "{volume} GPV",
    perfBonusLevelLabel: "Performance Bonus Level",
    footer:
      "With the CSI{symbol}, you can earn 10% on your Verified Customer Sales. As your monthly Performance Bonus level increases, your CSI{symbol} multiplier will be the difference between 10% and your Performance Bonus level.",
  },
  requirementsTitle: "How do I qualify? Here is the list of requirements.",
  bonusCalculation: {
    title: "How is this incentive calculated?",
    csiSectionTitle: "Customer Sales Incentive{symbol}",
    perfBonusSectionTitle: "Performance Bonus",
    verifiedBV: "Verified BV",
    csiAtLevel: "CSI{symbol} at {level}%",
    perfBonusAtLevel: "Performance Bonus at {level}%",
    totalPaid: "Total Paid",
    ppvExempt: "PPV Exempt",
    ppvRequired: "{target} PPV",
  },
  performanceBonus: {
    title: "Performance Bonus",
    levelLabel: "Level",
    gpvLabel: "GPV",
    bonusLabel: "Bonus",
  },
  transactionHistory: {
    title: "Transaction History",
    dateHeader: "Date",
    orderNumberHeader: "Order Number",
    pvHeader: "PV",
    aboNameHeader: "Customer Name",
    emptyState: "No transactions found.",
  },
  bonusSchedule: {
    title: "Bonus Schedule",
    levelHeader: "Level",
    multiplierHeader: "Multiplier",
    perfBonusHeader: "Performance Bonus",
    volumeHeader: "Volume",
    percentHeader: "Percent",
  },
  programFooter: {
    title: "Program Details",
    description: "The Customer Sales Incentive{symbol} program rewards {abo}s for customer sales volume.",
    disclaimer: "Bonus amounts are subject to change. See program terms for full details.",
  },
  requirementTiles: {
    PPV: { title: "Personal PV" },
    GPV: { title: "Group PV" },
    CustomerCount: { title: "Customer Count" },
    NewCustomer: { title: "New Customer" },
  },
};

export default content;
